import { Button, TextInput, required, useNotify } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";

// Shared add/edit dialog for the single-value profile identifiers (ORCID, Scopus ID, Web of Science ID).
const EditIdentifierDialog = ({ label, source, value, url, onSaved }) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    await dataProvider.customRequest(url, { [source]: data[source]?.trim() }, "PUT");
    notify(`${label} е запазен успешно`, { type: "success" });
    onSaved();
  };

  return (
    <FormModal
      titleContent={label}
      onConfirm={handleSubmit}
      defaultValues={{ [source]: value ?? "" }}
      saveTitle="Запази"
      triggerButton={
        <Button
          label={value ? "Редактирай" : "Добави"}
          startIcon={value ? <EditIcon /> : <AddIcon />}
        />
      }
    >
      <TextInput
        source={source}
        label={label}
        fullWidth
        validate={[required()]}
      />
    </FormModal>
  );
};

export default EditIdentifierDialog;
